// extracted by mini-css-extract-plugin
export default {"root":"TermsConditions_root__bjC+v","actions":"TermsConditions_actions__NTGbH"};